<template>
	<el-card >
		<div class="loading" v-loading="loading" v-if="fecthItems === 0"></div>
		<template v-else >
			<el-form ref="form" :label-position="'top'" label-width="100px" >
				<el-form-item label="Buscar por nombre de la tabla">
					<el-input
						placeholder="Busqueda"
						prefix-icon="el-icon-search"
						v-model="searchQuery"
						name="buscador"
						@change="searchInTable">
					</el-input>
				</el-form-item>
			</el-form>
			<app-modal-draggable v-if="modalDraggable" :content="show" :name="'title'" :table="'desktop'"></app-modal-draggable>
			<el-button v-if="multipleSelection.length > 0 && draggable" @click="handleSorteableMultiple()"><i class="el-icon-d-caret"></i></el-button>

			<el-table :data="show"  ref="multipleTable" @selection-change="handleSelectionChange">
				<el-table-column  type="selection"  width="55"></el-table-column>
				<el-table-column v-for="(c, i) in tableColumns" :key="i" :prop="c.prop" :label="c.label" :width="(c.prop == 'id' ? '80px' : 'auto')" sortable></el-table-column>
				<el-table-column label="Acciones">
					<template slot-scope="scope">
						<el-button size="mini" v-if="scope.row.response == 'mostrar'" type="primary" @click="handleAdd(scope.row.table)"><i class="el-icon-plus"></i></el-button>
						<template v-else>
							<el-button size="mini" @click="handleEdit(scope.row.table)"><i class="el-icon-edit"></i></el-button>
							<el-button size="mini" type="danger" @click="handleDelete(scope.row.table)"><i class="el-icon-delete"></i></el-button>
						</template>
					</template>
				</el-table-column>
			</el-table>
		</template>
	</el-card>
</template>


<script>
	import ApiService from '@/common/api.service'
    import { API_UPLOADS } from "@/common/config";	
    import { INTRANET_URL } from '@/common/config'
    import { mapGetters } from "vuex"
    import Draggable from '@/components/Dashboard/Modals/draggable'
	import tablaConPaginador from '@/components/_commons/tablaConPaginador'
	import { FECTH_DB_TABLES, FECTH_CHECK_BUILDER } from "@/store/actions.type";

	export default {
		name: 'MontarFormulario',
		components: {
			'app-modal-draggable': Draggable,
			 'app-table-paginate': tablaConPaginador,
        },
		created (){
            this.routeEdit = '/dashboard/' + this.$route.params.db + '/formulario/editar/'
            this.routeAdd = '/dashboard/' + this.$route.params.db + '/formulario/nuevo/'
			this.dbTables()
            setTimeout(() => { 
				this.show = this.paginador()
				this.pagesizes = [10, 20, 30, 40, 50, 100, this.show.length]
			}, 500);
			
		},
       	watch: {
            searchQuery (val, oldVal){
				this.searchInTable()
            }
        },
		data() {
			return {
				loading: true,
				table: null,
			
				// table
				routeAdd: null,
                routeEdit: null,
                deleterow: false,
                preview: null,
				modalDraggable: false,
                currentPage: 1,
                totalRegistros: null,
                itemsPorPagina: 10,
				tableColumns: [{
					'prop': 'table',
					'label': 'Nombre de la tabla'
				},
				{
					'prop': 'response',
					'label': 'Creado'
				}],
				tableData: [],
				show: [],
                row: null,
                multipleSelection: false,
                api_uploads: API_UPLOADS,
                pagesizes: null,
                editRow: 'id',
				deleteRow: 'id',
				draggable: true,
				searchQuery: null
			};
		},
		methods: {
			async dbTables() {
				if (localStorage.getItem('table')) {
					const a = await this.$store.dispatch(FECTH_DB_TABLES, {token: localStorage.getItem('token'), id_project: localStorage.getItem('table')})
					this.table = a
					this.table.forEach(e => {
						this.getCheckBuilder(e.TABLE_NAME)
					});
				}
			},
			async getCheckBuilder(name) {
				const a = await ApiService.post('dashboard/checkBuilder', { 
					name: name, 
					token: localStorage.getItem('token'), 
					project_id: localStorage.getItem('table')
				})
				this.tableData.push({ table: name, response: a.data})
				this.show.push({ table: name, response: a.data})
			},
            async eliminarBread(bread) {
                const a = await ApiService.post("dashboard/removeBread", {
                    table: 'bread',
                    token: localStorage.getItem("token"),
                    project_id: localStorage.getItem("table"),
                    bread: bread
				})
				this.deleterow = a.data
				this.dbTables()
				this.$message({
					type: 'success',
					message: 'Se ha eliminado correctamente'
				});
				this.loading = false						
				setTimeout(() => {
					this.$route.query.redirect || { name: "Dashboard-formularios" }
				}, 2000);
			},
			// Table 
			paginador() {
                const indiceInicio = (this.currentPage - 1) * this.itemsPorPagina;
                const indiceFinal =
                    indiceInicio + this.itemsPorPagina > this.show.length
                    ? this.show.length
                    : indiceInicio  + this.itemsPorPagina;
                this.totalRegistros = this.show.length
                return this.show.slice(indiceInicio , indiceFinal);
            },
            handleEdit(row) {
				this.$router.push(this.routeEdit + row) 
            },
            handleDelete(row) {
                this.$confirm('Esto eliminará permanentemente el registro. ¿Continuar?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                    }).then(() => {
						this.eliminarBread(row)
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: 'Se ha cancelado el borrado'
                    });          
                })
            },
			handleAdd(row) {
				this.$router.push(this.routeAdd + row) 
			},
			handleSelectionChange(val) {
                this.multipleSelection = val;
			},
			searchInTable() {
				this.show = this.tableData.filter( e => {
					return this.tableColumns.some( p => e[p.prop].toLowerCase().includes(this.searchQuery.toLowerCase()) )
				})
			}
		},
		computed: {
			fecthItems(){
				return this.tableData
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/MontarFormulario.vue